import axios from "axios";
import { config } from "../../api/config";
import { API_TYPE, ENVIRONMENT_MODE } from "../constants/SYSTEM";
import { setupInterceptorsTo } from "./interceptors";

const API = config(API_TYPE, ENVIRONMENT_MODE);

const getInstance = (url, headers) => {
  const instance = setupInterceptorsTo(
    axios.create({
      baseURL: url || API,
      headers: {
        accept: "text/plain",
        "Content-type": "application/json",
        ...headers
      },
    })
  );
  return instance;
}

export default getInstance;
